import { Button, Card, Tab } from "@metsooutotec/modes-react-components"
import { useCallback, useMemo } from "react"
import { ProvisionType } from "features/provisioning/provisions/models/provision-models"
import styles from "./provision-event-sidebar-selection.module.css"
import { EquipmentType } from "../../provisions-utils/provision-types"
import { provisionTypeToIcon } from "../../provisions-utils/provision-events-icon"

type EquipmentListItem = {
    id: string
    label: string
}

export type SidebarSelectionProps = {
    listItems: EquipmentListItem[]
    provisionType: ProvisionType
    equipmentType: EquipmentType
    onDeleteElement: (refId: string) => void
    onEquipmentTypeChanged: (equipmentType: EquipmentType) => void
}

export const SidebarSelection = ({ listItems, equipmentType, provisionType, onDeleteElement, onEquipmentTypeChanged }: SidebarSelectionProps) => {
    const sortedLiners = useMemo(() => [...listItems].sort((a, b) => a?.label?.localeCompare(b?.label)), [listItems])

    const handleDeleteElement = useCallback(
        (refId: string) => {
            onDeleteElement(refId)
        },
        [listItems],
    )

    const activeIndex = equipmentType === "Liner" ? 0 : 1

    return (
        <Card
            headerClassName='tab-align-in-card-header'
            contentClassName='list-align-in-card-content'
            data-cy='card'
            header={
                <Tab
                    as='div'
                    data-cy='tab'
                    activeIndex={activeIndex}
                    menu={{
                        pointing: true,
                        secondary: true,
                    }}
                    style={{ width: "100%" }}
                    panes={[{ menuItem: "Liners" }, { menuItem: "Sensors" }]}
                    onTabChange={(_, d) => {
                        onEquipmentTypeChanged(d.activeIndex === 0 ? "Liner" : "Sensor")
                    }}
                />
            }
            content={
                <div className={styles.elementList}>
                    {sortedLiners.map(element => {
                        return (
                            <div key={element.id} className={styles.elementRow}>
                                <div className={styles.elementName}>
                                    {provisionTypeToIcon(provisionType)}
                                    {element.label}
                                </div>
                                <div className={styles.elementActions}>
                                    <Button
                                        icon='icon-trash-16'
                                        labelPosition='left'
                                        onClick={() => handleDeleteElement(element.id)}
                                        size='small'
                                        subtle
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
        />
    )
}
